/* eslint-disable @typescript-eslint/no-explicit-any */
import { getAuthToken } from '@/utils/auth.utils'
import HttpRequest from './http-request'

class InventoryProvider extends HttpRequest {
  getWithdrawNoteById (id: string): Promise<any> {
    this.setHeader(getAuthToken())
    return this.get(`/withdraw-notes/${id}`)
  }
}

export default InventoryProvider
